// entries/admin_extension_tokens/components/FiltersBar.jsx
import React from "react"
import { useTranslation } from "react-i18next"

const STATUS_OPTIONS = [
  { value: "all", labelKey: "admin_extension_tokens.filters.all" },
  { value: "active_token", labelKey: "admin_extension_tokens.filters.active_token" },
  { value: "no_token", labelKey: "admin_extension_tokens.filters.no_token" },
]

const FiltersBar = ({ q, onQChange, status, onStatusChange }) => {
  const { t } = useTranslation()

  return (
    <div className="bg-white rounded-2xl border border-[#E7EAEF] p-3 mb-4 flex flex-col sm:flex-row gap-3 sm:items-center">
      <input
        type="text"
        value={q}
        onChange={(e) => onQChange(e.target.value)}
        placeholder={t("admin_extension_tokens.filters.search_placeholder")}
        className="flex-1 min-w-0 px-3 py-2 rounded-xl border border-[#E7EAEF] text-sm text-[#1F2937]
                   placeholder:text-[#9AA5B4] focus:outline-none focus:border-[#C7CDD6]"
      />

      <div className="flex gap-1.5 shrink-0">
        {STATUS_OPTIONS.map((opt) => (
          <button
            key={opt.value}
            onClick={() => onStatusChange(opt.value)}
            className={`px-3 py-2 rounded-xl text-sm font-medium transition-colors ${
              status === opt.value
                ? "bg-[#1F2937] text-white"
                : "bg-white border border-[#E7EAEF] text-[#1F2937] hover:bg-[#F4F6F9]"
            }`}
          >
            {t(opt.labelKey)}
          </button>
        ))}
      </div>
    </div>
  )
}

export default FiltersBar
